/**
 * 공통 Input 컴포넌트
 */

import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}

const InputWrapper = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  ${({ fullWidth }) => fullWidth && `width: 100%;`}
`;

const Label = styled.label`
  font-size: ${theme.fontSizes.sm};
  font-weight: 600;
  color: ${theme.colors.text};
`;

const StyledInput = styled.input<{ hasError?: boolean }>`
  padding: ${theme.spacing.md};
  font-size: ${theme.fontSizes.md};
  font-family: ${theme.fonts.main};
  border: 2px solid ${({ hasError }) => hasError ? theme.colors.accent : theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  transition: border-color 0.2s ease-in-out;

  &:focus {
    outline: none;
    border-color: ${({ hasError }) => hasError ? theme.colors.accent : theme.colors.secondary};
  }

  &::placeholder {
    color: ${theme.colors.textLight};
  }

  &:disabled {
    background-color: ${theme.colors.hover};
    cursor: not-allowed;
  }
`;

const ErrorText = styled.span`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.accent};
`;

export const Input: React.FC<InputProps> = ({ label, error, fullWidth, ...props }) => {
  return (
    <InputWrapper fullWidth={fullWidth}>
      {label && <Label>{label}</Label>}
      <StyledInput hasError={!!error} {...props} />
      {error && <ErrorText>{error}</ErrorText>}
    </InputWrapper>
  );
};
